import { OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { Subject, combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Selectors } from 'store/root-reducer';
var SelectDomainPopupComponent = /** @class */ (function () {
    function SelectDomainPopupComponent(store, dialogRef, cdRef) {
        this.store = store;
        this.dialogRef = dialogRef;
        this.cdRef = cdRef;
        this.unsubscribe = new Subject();
    }
    SelectDomainPopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        combineLatest([
            this.store.select(Selectors.domain.getDomains),
            this.store.select(Selectors.domain.getCurrentDomain)
        ])
            .pipe(takeUntil(this.unsubscribe))
            .subscribe(function (_a) {
            var domains = _a[0], currentDomain = _a[1];
            if (domains && currentDomain) {
                _this.currentDomain = domains.find(function (domain) { return domain.id === currentDomain.id; });
                _this.domains = domains;
                _this.cdRef.detectChanges();
            }
        });
    };
    SelectDomainPopupComponent.prototype.confirm = function () {
        this.dialogRef.close(this.currentDomain);
    };
    SelectDomainPopupComponent.prototype.closeDialog = function () {
        this.dialogRef.close();
    };
    SelectDomainPopupComponent.prototype.ngOnDestroy = function () {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    };
    return SelectDomainPopupComponent;
}());
export { SelectDomainPopupComponent };
